import React from 'react';

const User = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 14 13" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="User_a" d="M1250.87 36c0-3.51-4.6-5.2-6.94-5.2-2.34 0-6.93 1.69-6.93 5.2z" />
      <path id="User_b" d="M1243.93 29.07a3.04 3.04 0 0 0 3.04-3.04 3.04 3.04 0 0 0-3.04-3.03 3.04 3.04 0 0 0-3.03 3.03 3.04 3.04 0 0 0 3.03 3.04z" />
    </defs>
    <use fill="currentColor" xlinkHref="#User_a" transform="translate(-1237 -23)" />
    <use fill="currentColor" xlinkHref="#User_b" transform="translate(-1237 -23)" />
  </svg>
);

export default User;



// WEBPACK FOOTER //
// ./src/common/icons/User.js